import { render, staticRenderFns } from "./BrandModelSerialView.vue?vue&type=template&id=70b54e4f&"
import script from "./BrandModelSerialView.vue?vue&type=script&lang=js&"
export * from "./BrandModelSerialView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports